/**
=========================================================
* Argon Dashboard 2 PRO MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-mui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import Grid from "@mui/material/Grid";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useState } from "react";

// @mui material components

// Argon Dashboard 2 PRO MUI components
import { ClientTable } from "0.Mine/0.Components/CRM/CustomerDB/ClientTable";
import SequenceInfo from "0.Mine/0.Components/CRM/Sequence/Sequence";
import RuleBuilder from "0.Mine/0.Components/CRM/SequenceRules/RuleBuilder";
import ArgonBox from "components/ArgonBox";

// Argon Dashboard 2 PRO MUI example components
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import ComplexReportsDoughnutChart from "examples/Charts/DoughnutCharts/ComplexReportsDoughnutChart";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import BusinessNavbar from "examples/Navbars/DashboardNavbar/businessNavbar";
import complexReportsDoughnutChartData from "layouts/applications/analytics/data/complexReportsDoughnutChartData";

function CRMClients() {
  return (
    <DashboardLayout>
      <BusinessNavbar />
      <ArgonBox py={3}>
        <ArgonBox mb={3}></ArgonBox>
        <ClientTable />
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CRMClients;
